import { useCallback, useEffect, useMemo, useState } from 'react'
import { useIpLocation } from './useIpLocation'
import features from '../../components/features'
import settings from '../../components/settings'

export const useDeviceLocation = (enabled) => {
  const [geolocation, setGeolocation] = useState({
    loaded: !features.useBrowserGeolocation,
  })
  const { data: ipLocation } = useIpLocation(enabled && geolocation.loaded)

  const getCurrentGeoPositionSuccess = useCallback((position) => {
    setGeolocation({
      loaded: true,
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
    })
  }, [])

  const getCurrentGeoPositionError = useCallback(() => {
    setGeolocation({
      loaded: true,
    })
  }, [])

  useEffect(() => {
    if (!enabled || geolocation.loaded) {
      return
    }
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        getCurrentGeoPositionSuccess,
        getCurrentGeoPositionError
      )
    } else {
      setGeolocation({
        loaded: true,
      })
    }
  }, [enabled])

  const location = useMemo(
    () =>
      ipLocation
        ? {
            city: ipLocation.city || settings.fallbackAddress.city,
            countryName:
              ipLocation.countryName || settings.fallbackAddress.countryName,
            postalCode:
              ipLocation.postalCode || settings.fallbackAddress.postalCode,
            latitude: geolocation.latitude || ipLocation.latitude,
            longitude: geolocation.longitude || ipLocation.longitude,
          }
        : undefined,
    [ipLocation, geolocation]
  )

  return location
}
